<template>
  <div class="text-size-widget">
    <span :class="['text-size-control', 'text-sm', {active: textSize == 'sm'}]" @click="changeTextSize('sm')">{{ $t('textSizeText') }}</span>
    <span :class="['text-size-control', 'text-md', {active: textSize == 'md'}]" @click="changeTextSize('md')">{{ $t('textSizeText') }}</span>
    <span :class="['text-size-control', 'text-lg', {active: textSize == 'lg'}]" @click="changeTextSize('lg')">{{ $t('textSizeText') }}</span>
  </div>
</template>

<script>
  import i18n from '../i18n';

  export default {
    scaifeConfig: {
      displayName: () => i18n.t('textSizeWidgetTitle'),
    },
    computed: {
      textSize() {
        return this.$store.state.readerTextSize;
      },
    },
    methods: {
      changeTextSize(size) {
        this.$store.dispatch('setTextSize', { size });
      },
    },
  };
</script>

<style lang="scss">
  @import "../_variables.scss";

  #app[data-locale="ar"] {
    .widget h2 {
      direction: rtl;
      line-height: 40px;
      .heading {
        letter-spacing: normal;
        font-size: 32px;
        font-family: $ar-font-family;
        color: $gray-600;
      }
    }
    .text-size-control {
      font-family: $ar-font-family;
      color: $gray-600;
      padding: 8px;
      &.text-sm {
        font-size: $ar-text-sm;
      }

      &.text-md {
        font-size: $ar-text-md;
      }

      &.text-lg {
        font-size: $ar-text-lg;
      }
    }
    .text-size-control.text-sm.active,
    .text-size-control.text-md.active,
    .text-size-control.text-lg.active,
    {
      color: $gray-900;
      font-weight: bold;
    }

  }

  .text-size-widget {
    margin-left: 10px;
    align-items: center;
    flex-direction: row;
  }
  #app[data-locale="ar"] .text-size-widget {
    direction: rtl;
  }

  .text-size-control {
    cursor: pointer;
    color: #666;
    padding: 2px;

    font-family: "Noto Serif";

    &.selected {
      color: $gray-900;
    }

    &:hover {
      color: $gray-900;
    }

    &.text-sm {
      font-size: 14px;
    }

    &.text-md {
      font-size: 18px;
    }

    &.text-lg {
      font-size: 22px;
    }
  }

  .text-size-control.text-sm.active,
  .text-size-control.text-md.active,
  .text-size-control.text-lg.active,
  {
    color: $gray-900;
    font-weight: bold;
  }
</style>
